const additonalSchools=[["Academy of Art University","https://studentca.anthem.com/student/schools/aaulahc"],
["Albert Einstein","https://student.empireblue.com/student/schools/aecm"],
["AMDA CA","https://studentca.anthem.com/student/schools/amda-ca"],
["AMDA NY","https://student.empireblue.com/student/schools/amda"],
["Azusa Pacific University","https://studentca.anthem.com/student/schools/apu"],
["Bowdoin College","https://student.anthem.com/student/schools/bowdoin"],
["California Institute of Technology","https://studentca.anthem.com/student/schools/caltech"],
["California State University, East Bay","https://studentca.anthem.com/student/schools/csueb"],
["California State University, Fresno","https://studentca.anthem.com/student/schools/csu-fresno"],
["California State University, Fullerton","https://studentca.anthem.com/student/schools/csuf"],
["California State University, Long Beach","https://studentca.anthem.com/student/schools/csulb"],
["California State University, Northridge","https://studentca.anthem.com/student/schools/csun"],
["California State University, San Bernardino","https://studentca.anthem.com/student/schools/csusb"],
["Cañada College","https://studentca.anthem.com/student/schools/canada"],
["City College of San Francisco","https://studentca.anthem.com/student/schools/ccsf"],
["College of San Mateo","https://studentca.anthem.com/student/schools/csm"],
["Colorado College","https://student.anthem.com/student/schools/cc"],
["Colorado School of Mines","https://student.anthem.com/student/schools/csms"],
["Colorado State University, Fort Collins","https://student.anthem.com/student/schools/csufc"],
["De Anza College","https://studentca.anthem.com/student/schools/dc"],
["East Los Angeles College","https://studentca.anthem.com/student/schools/elac"],
["Foothill College","https://studentca.anthem.com/student/schools/fc"],
["Hampton University","https://student.anthem.com/student/schools/hu"],
["Indiana University","https://student.anthem.com/student/schools/iu"],
["Los Angeles City College","https://studentca.anthem.com/student/schools/lacc"],
["Los Angeles Harbor College","https://studentca.anthem.com/student/schools/lahc"],
["Los Angeles Mission College","https://studentca.anthem.com/student/schools/lamc"],
["Los Angeles Pierce College","https://studentca.anthem.com/student/schools/lapc"],
["Los Angeles Southwest College","https://studentca.anthem.com/student/schools/lasc"],
["Los Angeles Trade Tech College","https://studentca.anthem.com/student/schools/lattc"],
["Los Angeles Valley College","https://studentca.anthem.com/student/schools/lavc"],
["Marist College","https://student.empireblue.com/student/schools/marist"],
["Marymount Manhattan College","https://student.empireblue.com/student/schools/mmc"],
["Missouri S & T","https://student.anthem.com/student/schools/mst"],
["Morehouse School of Medicine","https://student.anthem.com/student/schools/msm"],
["Oberlin College and Conservatory","https://student.anthem.com/student/schools/oberlin"],
["Otis College of Art & Design","https://studentca.anthem.com/student/schools/otis"],
["Pace University","https://student.empireblue.com/student/schools/pace"],
["Pepperdine University","https://studentca.anthem.com/student/schools/pepperdine"],
["Regis University","https://student.anthem.com/student/schools/regis"],
["Saint John's University","https://student.empireblue.com/student/schools/sju"],
["Saint Mary's College of California","https://studentca.anthem.com/student/schools/smc"],
["Samuel Merritt University","https://studentca.anthem.com/student/schools/smu"],
["San Diego State University","https://studentca.anthem.com/student/schools/sdsu"],
["Santa Clara University","https://studentca.anthem.com/student/schools/scu"],
["Santa Monica College","https://studentca.anthem.com/student/schools/smc-ca"],
["Silicon Valley Intensive English Program","https://studentca.anthem.com/student/schools/sviep"],
["Skyline College","https://studentca.anthem.com/student/schools/sc"],
["Soka University of America","https://studentca.anthem.com/student/schools/soka"],
["Southern California School of Architecture","https://studentca.anthem.com/student/schools/sci-arc"],
["Southern New Hampshire University","https://student.anthem.com/student/schools/snhu"],
["The University of Toledo","https://student.anthem.com/student/schools/utoledo"],
["University of California - Extension-International","https://studentca.anthem.com/student/schools/uc-ext"],
["University of California Los Angeles – Extension","https://studentca.anthem.com/student/schools/ucla-ext"],
["University of Colorado Boulder","https://student.anthem.com/student/schools/cub"],
["University of Kentucky","https://student.anthem.com/student/schools/uky"],
["University of Louisville","https://student.anthem.com/student/schools/uofl"],
["University of Maine System","https://student.anthem.com/student/schools/ums"],
["University of Missouri","https://student.anthem.com/student/schools/mizzou"],
["University of Missouri - Kansas City","https://student.anthem.com/student/schools/umkc"],
["University of Missouri - St. Louis","https://student.anthem.com/student/schools/umsl"],
["University of Nevada, Reno","https://student.anthem.com/student/schools/un-reno"],
["University of the Pacific","https://studentca.anthem.com/student/schools/pacific"],
["Utah State University","https://student.anthem.com/student/schools/usu"],
["Valparaiso University","https://student.anthem.com/student/schools/valpo"],
["West Los Angeles College","https://studentca.anthem.com/student/schools/wlac"],
["Wright State University","https://student.anthem.com/student/schools/wsu"],
["Xavier University","https://student.anthem.com/student/schools/xu"]]


export default additonalSchools;